<ion-button
  (click)="handleClick()"
  color="button-primary"
  class="retry-button-rounded"
  mode="ios"
  [disabled]="isDisabled"
>
  <span class="fw-600 fs-14 ion-text-capitalize"> {{ 'General.Retry' | translate }} </span>
</ion-button>
